import { call, put, takeLatest } from 'redux-saga/effects'
import {
  UPDATE_SELECTED_COLUMNS,
  STORE_SELECTED_COLUMNS,
  FETCH_SELECTED_COLUMNS,
  UPDATE_SELECTED_COLUMNS_WIDTH,
  FETCH_SELECTED_COLUMNS_WIDTH,
  STORE_SELECTED_COLUMNS_WIDTH,
} from '../../constants/Tables/Common'
import {
  fetchTableColumns,
  fetchTableColumnsWidth,
  updateSelectedColumnsInDB,
  updateColumnsWidthInDB,
} from '../../../firebase/fireStore/tableColumnDBMethods'
 
function* fetchTableColumnsList(action) {
  try {
    const selectedDbCols = yield call(fetchTableColumns, action)
    let resPayload = {
      type: UPDATE_SELECTED_COLUMNS,
      tableName: action.tableName,
    }
    if (selectedDbCols.length) {
      resPayload.updatedTableColObj = {
        ...action.tableColObj,
        selectedColumns: selectedDbCols,
        isFirstRun: false,
      }
    } else {
      const allCols = action.tableColObj.allColumns.map((obj) => obj.value)
      const hiddenCols = action.tableColObj.hiddenColumns.map((obj) => obj.value)
      const defaultSelectedCols = allCols.filter(item => !hiddenCols.includes(item))
      resPayload.updatedTableColObj = {
        ...action.tableColObj,
        selectedColumns: defaultSelectedCols,
        isFirstRun: false,
      }
    }
    yield put(resPayload)
  } catch (error) {
    console.error('fetchTableColumns err', error)
    yield put({ type: UPDATE_SELECTED_COLUMNS, error })
  }
}
 
function* fetchTableColumnsWidthList(action) {
  try {
    const columnWidths = yield call(fetchTableColumnsWidth, action);
    let resPayload = {
      type: UPDATE_SELECTED_COLUMNS_WIDTH,
      tableName: action.tableName,
    };
 
    if (Object.keys(columnWidths).length) {
      // If column widths are fetched successfully
      resPayload.updatedTableColObj = {
        ...action.tableColObj,
        tableName: action.tableName,
        colWidths: columnWidths, // Directly assign the fetched widths
        isFirstRun: false,
      };
    } else {
      // Fallback to default widths if no widths are fetched
      const defaultColWidths = action.tableColObj.allColumns.reduce((acc, col) => {
        acc[col.value] = col.width; // Use default width if not specified
        return acc;
      }, {});
 
      resPayload.updatedTableColObj = {
        ...action.tableColObj,
        colWidths: defaultColWidths,
        isFirstRun: false,
      };
    }
    yield put(resPayload);
  } catch (error) {
    console.error('fetchTableColumnsWidthList error', error);
    yield put({ type: UPDATE_SELECTED_COLUMNS_WIDTH, error });
  }
}
 
function* storeTableColumnsWidth(action) {
  try {
    let selectedDbCols;
    if (action.updateDb) {
      selectedDbCols = yield call(updateColumnsWidthInDB, action);
    }
 
    let resPayload = {
      type: UPDATE_SELECTED_COLUMNS_WIDTH,
      tableName: action.tableName,
    }
    resPayload.updatedTableColObj = {
      ...action.tableColObj,
      colWidths: selectedDbCols || action.colWidths,
      isFirstRun: true,
    }
    yield put(resPayload)
  } catch (error) {
    console.error('storeTableColumnsList err', error)
    yield put({ type: UPDATE_SELECTED_COLUMNS_WIDTH, error })
  }
}
function* storeTableColumnsList(action) {
  try {
    const selectedDbCols = yield call(updateSelectedColumnsInDB, action)
    let resPayload = {
      type: UPDATE_SELECTED_COLUMNS,
      tableName: action.tableName,
    }
    resPayload.updatedTableColObj = {
      ...action.tableColObj,
      selectedColumns: selectedDbCols,
      isFirstRun: false,
    }
    yield put(resPayload)
  } catch (error) {
    console.error('storeTableColumnsList err', error)
    yield put({ type: UPDATE_SELECTED_COLUMNS, error })
  }
}
 
export function* fetchTableColumnListSaga() {
  yield takeLatest(FETCH_SELECTED_COLUMNS, fetchTableColumnsList)
}
 
export function* fetchTableColumnWidthListSaga() {
  yield takeLatest(FETCH_SELECTED_COLUMNS_WIDTH, fetchTableColumnsWidthList);
}
 
export function* updateTableColumnListSaga() {
  yield takeLatest(STORE_SELECTED_COLUMNS, storeTableColumnsList)
}
 
export function* updateTableColumnWidthSaga() {
  yield takeLatest(STORE_SELECTED_COLUMNS_WIDTH, storeTableColumnsWidth)
}